<template>
  <div>
    <v-container fluid>
      <v-card class="card2" style="margin-top: 1rem">
        <v-flex class="flex">
          <v-row class="mb-4">
            <v-col cols="12 pt-0">
              <h1 style="font-weight: 600; font-size: 28px;" class="ml-5">{{ $t('promptTemplateDetails') }}</h1>
            </v-col>
            <v-col cols="12" sm="12" md="5">
              <span class="field-label">
                {{ $t('promptTemplateGroupName') }}
                <span style="color: red;">*</span>
                <v-tooltip location="top" max-width="300px">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" color="grey-darken-1" size="small" class="ml-1">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span>{{ $t('_setTemplateGroupNameTooltip') }}</span>
                </v-tooltip>
              </span>
              <v-text-field id="textgroupname-field-prompt" :placeholder="$t('promptTemplateGroupName')" v-model="PromptTemplate.Name"
                variant="outlined" density="comfortable" color="#7e2815" class="modern-text-field ml-6" clearable
                hide-details="auto" :readonly="!!PromptTemplate.GroupPromptTemplateID"
                :disabled="!!PromptTemplate.GroupPromptTemplateID">
              </v-text-field>
            </v-col>
          </v-row>

          <v-row class="mb-4">
            <v-col cols="12" md="5">
              <h1 style="font-weight: 600; font-size: 28px;" class="ml-5">{{ $t('promptTemplateList') }}</h1>
            </v-col>
            <v-col cols="12" md="7" class="d-flex justify-end align-center">
              <div class="custom-search-input-wrapper mr-3">
                <div class="custom-search-input-container">
                  <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                  <input id="groupname-field-search-groupprompt" type="text" :placeholder="$t('templateName')"
                    :aria-label="$t('templateName')"
                    class="custom-search-input" v-model="searchName" @keydown.enter="Search" />
                  <v-icon class="clear-icon" :style="searchName ? '' : 'color: transparent !important;'"
                    @click="searchName = ''">
                    mdi-close-circle
                  </v-icon>
                </div>
              </div>
              <v-btn id="button-add-prompt" @click="ShowDialogAdd()" variant="flat" size="large"
                class="control-btn create-btn ml-0" prepend-icon="mdi-plus" elevation="2" style="margin-right: 20px">
                {{ $t('addTemplate') }}
              </v-btn>
            </v-col>
          </v-row>

          <v-data-table-server v-model:options="options" :items-per-page="options.itemsPerPage" :items="dataTable"
            :headers="headers" :items-length="totalTable" :loading="loadingTable" class="px-5">
            <template v-slot:item="{ item }">
              <tr style="height: 80px">
                <td style="text-align: center">{{ item.no }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.prompt }}</td>
                <td>
                  <div class="d-flex justify-center align-center">
                    <div class="status-toggle-wrapper">
                      <v-switch id="switch-status-prompt" v-model="item.activeStatus" inset
                        @change="ChangeActiveStatus(item)"
                        :class="[
                          'publication-toggle',
                          item.activeStatus
                            ? 'publication-toggle--active'
                            : 'publication-toggle--inactive'
                        ]"
                        hide-details
                        density="compact"></v-switch>
                    </div>
                  </div>
                </td>
                <td style="text-align: center">
                  <div class="action-group" style="justify-content: center">
                    <!-- Edit -->
                    <v-btn id="button-edit-popupedit-prompt" variant="text" density="comfortable"
                      @click="ShowDialogEdit(item)" class="action-btn edit-btn" icon>
                      <v-img :src="images.editBtn" width="23" height="23"></v-img>
                      <v-tooltip activator="parent" location="top">
                        {{ $t('edit') }}
                      </v-tooltip>
                    </v-btn>
                    <!-- Delete -->
                    <v-btn id="button-delete-popupedit-prompt" variant="text" density="comfortable"
                      @click="ShowDialogDelete(item)" class="action-btn delete-btn" icon>
                      <v-img :src="images.deleteBtn" width="23" height="23"></v-img>
                      <v-tooltip activator="parent" location="top">
                        {{ $t('delete') }}
                      </v-tooltip>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </template>
            <!-- 👇 Custom footer area -->
            <template v-slot:bottom>
              <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
                <div>{{ $t('totalResults') }} {{ searchTotalTable }}</div>

                <v-data-table-footer v-model:items-per-page="itemsPerPage" :page="options.page"
                  :length="Math.ceil(searchTotalTable / itemsPerPage)" />
              </div>
            </template>
            <!-- No Data Slot -->
            <template v-slot:no-data>
              <div class="no-data-container">
                <div class="no-data-content">
                  <h3 style="color: #646464!important;">{{ $t('noDataAvailable') }}</h3>
                </div>
              </div>
            </template>
          </v-data-table-server>
        </v-flex>
      </v-card>

      <!-- Add Dialog -->
      <v-dialog v-model="DialogAddData" persistent max-width="700px" class="modern-dialog">
        <PromptTemplateDialogCard
          mode="add"
          v-model="ModelData"
          :rules="rules"
          :loading="loading"
          :images="images"
          :max-length-char="maxLengthChar"
          @save="AddPromptTemplate"
          @close="CloseDialog"
        />
      </v-dialog>

      <!-- Edit Dialog -->
      <v-dialog v-model="DialogEditData" persistent max-width="700px" class="modern-dialog">
        <PromptTemplateDialogCard
          mode="edit"
          v-model="ModelData"
          :rules="rules"
          :loading="loading"
          :images="images"
          :max-length-char="maxLengthChar"
          @save="UpdatePromptTemplate"
          @close="CloseDialog"
        />
      </v-dialog>
      <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">{{ $t('deletePromptTemplate') }}</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelDelete"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
            {{ $t('_confirmDeletePromptTemplate') }}
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="DeletePromptTemplate()"
          >
            <v-img :src="images.deleteIcon" width="20" height="20" class="mr-2"/>
            {{ $t('delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Custom Warning Dialog -->
    <v-dialog v-model="dialog_warn" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="warn-dialog-header">
          <span class="reprocess-dialog-title">{{ $t('_promptTemplateInfoRequired') }}</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="dialog_warn = false"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
            {{ $t('_fillAllRequiredInfo') }}
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="reprocess-confirm-btn"
            @click="dialog_warn = false"
          >
            {{ $t('ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-overlay :model-value="loading" class="align-center justify-center" persistent>
        <v-card class="loading-card" elevation="8">
          <v-card-text class="text-center">
            <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
            <h3 class="loading-title">{{ $t('loading') }}</h3>
            <p class="loading-subtitle">{{ $t('pleaseWait') }}</p>
          </v-card-text>
        </v-card>
      </v-overlay>
    </v-container>

    <v-dialog v-model="dialog_template_onoff" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="chunk-dialog-header">
          <span class="chunk-dialog-title">{{ $t(TemplateSwitchHeader) }}</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelSwitchTemplate()"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span style="font-weight: 500;" v-if="TemplateSwitchHeader === 'turnOffTemplate'">
            {{ $t('_confirmTurnOffTemplate') }}
          </span>
          <span style="font-weight: 500;" v-else>
            {{ $t('_confirmTurnOnTemplate') }}
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelSwitchTemplate()"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            class="chunk-confirm-btn"
            @click="confirmSwitchTemplate()"
          >
            {{ $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import LogTrace from "@/api/function.js";
import editBtn from '@/assets/images/editbutton.png';
import deleteBtn from '@/assets/images/trashbutton.png';
import deleteIcon from "@/assets/images/trash-solid.svg";
import saveImg from '@/assets/images/savecard.png';
import PromptTemplateDialogCard from "@/components/PromptTemplateDialogCard.vue";
export default {
  name: "PromptTemplate",
  inject: ["flagNav",'FontColorTitle','SubNavbarBackGround'],
  mixins: [LogTrace],
  components: { PromptTemplateDialogCard },
  data: () => ({
    // maxLengthChar: 4000,
    loadingTable: false,
    isInitialized: false,
    dataTable: [],
    DialogAddData: false,
    DialogEditData: false,
    validForm: false,
    maxLengthChar: 5000,
    ModelData: {
      id: null,
      name: null,
      prompt: null,
      activeStatus: false,
      groupName: null,
    },
    loading: false,
    today: null,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    totalTable: 0,
    searchTotalTable: 0,
    itemsPerPage: 10,
    rules: {
      required: (value) => !!value || "Required.",
    },
    images: {
      deleteBtn: deleteBtn,
      editBtn: editBtn,
      deleteIcon: deleteIcon,
      saveImg: saveImg,
    },
    dialog_delete: false,
    dialog_warn: false,
    isFirst: true,
    isSearch: false,
    sortBy: [],
    sortDesc: [],
    PromptTemplate: {
      GroupPromptTemplateID: null,
      ID: null,
      Name: null,
      Prompt: null,
      ActiveStatus: false,
    },
    dialog_template_onoff: false,
    TemplateSwitchHeader: "",
    selectedItem : null,
    searchName: "",
  }),
  computed: {
    headers() {
      return [
        {
          title: this.$t("no"),
          align: "center",
          sortable: false,
          width: "95px",
        },
        {
          title: this.$t("templateName"),
          align: "left",
          sortable: true,
          value: "name",
          width: "250px",
        },
        {
          title: this.$t("prompt"),
          align: "left",
          sortable: true,
          value: "prompt",
          width: "800px",
        },
        {
          title: this.$t("Status"),
          align: "center",
          sortable: true,
          value: "activeStatus",
          width: "200px",
        },
        {
          title: this.$t("manage"),
          align: "center",
          sortable: false,
          width: "200px",
        },
      ];
    },
  },
  async mounted() {
    this.GetDate();
    if (this.$route.query.id) {

      this.PromptTemplate.Name = this.$route.query.name;
      this.PromptTemplate.GroupPromptTemplateID = this.$route.query.id;
    }
    await this.GetPromptTemplate();
    this.isInitialized = true;
  },
  watch: {
    options: {
      handler() {
        if (this.isInitialized) {
          this.GetPromptTemplate();
        }
      },
      deep: true,
    },
  },
  methods: {
    Search() {
      this.GetPromptTemplate();
    },
    GetPromptTemplate() {
      try {
        this.loadingTable = true;
        let { page, itemsPerPage, sortBy } = this.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === "desc";
        }
        let temp = {
          name: this.searchName,
          page: this.isSearch ? 1 : page,
          perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
          id: this.PromptTemplate.GroupPromptTemplateID,
          sortDesc: sortOrder,
          sortBy: sortField,
        };
        this.$call.GetPromptTemplate(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.dataTable = dataResponse.data.listData;
              this.searchTotalTable = dataResponse.data.total;
              this.totalTable = this.isFirst
                ? dataResponse.data.total
                : this.totalTable;
            } else {
              this.dataTable = [];
              this.searchTotalTable = 0;
              this.totalTable = 0;
            }
            this.loadingTable = false;
            this.isFirst = false;
            this.isSearch = false;
          },
          (errorResource) => {
            this.loadingTable = false;
            this.isSearch = false;
            if (errorResource.status != 0) {
              console.error(errorResource);
            }
          }
        );
      } catch (error) { //NOSONAR
        // intentionally ignored
      }
    },

    async AddPromptTemplate() {
      if (
        !this.PromptTemplate.GroupPromptTemplateID &&
        (!this.PromptTemplate.Name || this.PromptTemplate.Name.trim() === "")
      ) {
        this.DialogAddData = false;
        this.dialog_warn = true;
        return;
      }
      if (
        this.ModelData.name != null &&
        this.ModelData.name.trim() != "" &&
        this.ModelData.prompt != null &&
        this.ModelData.prompt.trim() != ""
      ) {
        this.loading = true;
        let temp = {
          Name: this.ModelData.name.trim(),
          Prompt: this.ModelData.prompt.trim(),
          ActiveStatus: this.ModelData.activeStatus,
          groupName: this.PromptTemplate.Name,
          GroupPromptTemplateID:
            this.PromptTemplate.GroupPromptTemplateID ?? null,
        };
         this.$call.AddPromptTemplate(
          temp,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              this.$swal.fire({
                title: this.$t('_promptTemplateSavedSuccess'),
                    showConfirmButton: false,
                    timer: 1500,
                     position: 'top',
                    customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
              });
              this.totalTable++;
              this.DialogAddData = false;
              this.PromptTemplate.GroupPromptTemplateID = dataResponse.data;
               this.GetPromptTemplate();
            } else if (dataResponse.status == 3) {
              this.$swal.fire({
                icon: "warning",
                title: this.$t("warning"),
                text: dataResponse.message,
                showConfirmButton: false,
                timer: 1800,
              });
            } else {
              this.DialogAddData = false;
            }
            const currentQuery = { ...this.$route.query };
            currentQuery.name = this.PromptTemplate.Name;
            currentQuery.id = dataResponse.data;
            this.loading = false;
            this.$router.replace({
              path: this.$route.path,
              query: currentQuery,
            })
            console.log(dataResponse);
          },
          (errorResource) => this.onSaveError(errorResource)
        );
      } else {
        this.showFillInfoWarning();
      }
    },
    async UpdatePromptTemplate() {
      if (
        this.ModelData.name != null &&
        this.ModelData.name.trim() != "" &&
        this.ModelData.prompt != null &&
        this.ModelData.prompt.trim() != ""
      ) {
        this.loading = true;
        let temp = {
          Name: this.ModelData.name.trim(),
          Prompt: this.ModelData.prompt.trim(),
          ActiveStatus: this.ModelData.activeStatus,
          groupName: this.PromptTemplate.Name,
          GroupPromptTemplateID:
            this.PromptTemplate.GroupPromptTemplateID ?? null,
          PromptTemplateID: this.ModelData.id,
        };
        await this.$call.UpdatePromptTemplate(
          temp,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              this.loading = false;
              if (dataResponse.data.status == false) { //NOSONAR
                this.$swal.fire({
                  icon: "warning",
                  title: this.$t("warning"),
                  text: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1800,
                });
              } else {
                this.$swal.fire({
                  title: this.$t('_promptTemplateUpdatedSuccess'),
                    showConfirmButton: false,
                    timer: 1500,
                    position: 'top',
                    customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                });
                this.DialogEditData = false;
              }
              await this.GetPromptTemplate();
            } else {
              this.DialogEditData = false;
              this.loading = false;
            }
          },
          (errorResource) => this.onSaveError(errorResource)
        );
      } else {
        this.showFillInfoWarning();
      }
    },

    cancelSwitchTemplate(){
      this.dialog_template_onoff = false;
      this.selectedItem.activeStatus = !this.selectedItem.activeStatus;
    },

    ChangeActiveStatus(val) {
      this.TemplateSwitchHeader = val.activeStatus
        ? 'turnOnTemplate'
        : 'turnOffTemplate';
      this.dialog_template_onoff = true;
      this.selectedItem = val;
    },
    
    async confirmSwitchTemplate() {
      let val = this.selectedItem;
      this.dialog_template_onoff = false;
      if (
        val.name != null &&
        val.name.trim() != "" &&
        val.prompt != null &&
        val.prompt.trim() != ""
      ) {
        this.loading = true;
        let temp = {
          PromptTemplateID: val.id,
          Name: val.name.trim(),
          Prompt: val.prompt.trim(),
          ActiveStatus: val.activeStatus,
          GroupPromptTemplateID: this.PromptTemplate.GroupPromptTemplateID,
        };
        await this.$call.UpdatePromptTemplate(
          temp,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              this.loading = false;
              if (dataResponse.data.status == false) { //NOSONAR
                this.$swal.fire({
                  icon: "warning",
                  title: this.$t("warning"),
                  text: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1800,
                });
              } else {
                let msgSuccess = "✔ " +
                  dataResponse.data.message;
                this.$swal.fire({
                  title: msgSuccess,
                  showConfirmButton: false,
                  timer: 1500,
                  position: 'top',
                  backdrop: true,
                  customClass: {
                          popup: 'success-banner',
                          title: 'success-banner-title'
                        },
                });
                this.DialogEditData = false;
              }
              await this.GetPromptTemplate();
            } else {
              this.DialogEditData = false;
              this.loading = false;
            }
          },
          (errorResource) => this.onSaveError(errorResource)
        );
      } else {
        this.showFillInfoWarning();
      }
    },

    async DeletePromptTemplate() {
      try {
            this.loading = true;
            this.dialog_delete = false;
            let temp = {
              ID: this.ModelData.id,
            };
            this.$call.DeletePromptTemplate(
              temp,
              (dataResponse) => {
                if (dataResponse.status == 0) {
                  this.$swal.fire({
                    title: this.$t('_promptTemplateDeletedSuccess'),
                    showConfirmButton: false,
                    timer: 1500,
                     position: 'top',
                    customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                  });
                  this.loading = false;
                  this.GetPromptTemplate();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    title: dataResponse.message,
                    showConfirmButton: false,
                    timer: 1800,
                  });
                  this.loading = false;
                  this.GetPromptTemplate();
                }
                this.loading = false;
              },
              (errorResource) => {
                this.loading = false;
                if (errorResource.status != 0) {
                  console.error(errorResource);
                }
              }
            );
      } catch (error) {
        this.LogTrace(error, 'DeletePromptTemplate');
      }
    },

    ShowDialogAdd() {
      this.DialogAddData = true;
      this.ModelData.id = null;
      this.ModelData.name = null;
      this.ModelData.prompt = null;
      this.ModelData.activeStatus = false;


    },

    ShowDialogEdit(item) {
      this.DialogEditData = true;
      this.ModelData.id = item.id;
      this.ModelData.name = item.name;
      this.ModelData.prompt = item.prompt;
      this.ModelData.activeStatus = item.activeStatus;
    },

    ShowDialogDelete(item) {
      this.ModelData.id = item.id;
      this.dialog_delete = true;
    },
    cancelDelete() {
      this.dialog_delete = false;
      this.ModelData.id = null;
    },
    CloseDialog() {
      this.DialogAddData = false;
      this.DialogEditData = false;
      this.ModelData.id = null;
      this.ModelData.name = null;
      this.ModelData.prompt = null;
    },
    // Shared helpers extracted from Add/Update/confirmSwitch to remove duplicated blocks (SonarQube).
    showFillInfoWarning() {
      this.$swal.fire({
        icon: "warning",
        title: this.$t("warning"),
        text: this.$t("pleasefillininformation"),
        showConfirmButton: false,
        timer: 1800,
      });
    },
    onSaveError(errorResource) {
      this.loading = false;
      if (errorResource.status != 0) {
        console.error(errorResource);
      }
    },
  },
};
</script>
<style scoped>
/* =============================================================================
   BASE STYLES
   ============================================================================= */
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

/* =============================================================================
   TEXT FIELD STYLES
   ============================================================================= */
.modern-text-field {
  margin-top: 8px;
}

.modern-text-field :deep(.v-field) {
  border-radius: 16px !important;
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
}

.modern-text-field :deep(.v-field__outline) {
  border-width: 2px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  transition: all 0.3s ease !important;
}

.modern-text-field :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-text-field:hover :deep(.v-field__outline) {
  border-color: rgba(25, 118, 210, 0.6) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

/* Read-only state */
.modern-text-field :deep(.v-field--readonly) {
  background: #f8f9fa !important;
  opacity: 0.9;
}

.modern-text-field :deep(.v-field--readonly .v-field__outline) {
  border-color: rgba(0, 0, 0, 0.08) !important;
  border-style: dashed !important;
}

.modern-text-field :deep(.v-field--readonly:hover .v-field__outline) {
  border-color: rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04) !important;
}

/* Label styling */
.modern-text-field :deep(.v-placeholder) {
  font-weight: 400 !important;
  color: #495057 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.25px !important;
}

.modern-text-field :deep(.v-field--focused .v-label) {
  color: #1976d2 !important;
}

.modern-text-field :deep(.v-field--readonly .v-label) {
  color: #6c757d !important;
}

/* Input text styling */
.modern-text-field :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 400 !important;
  color: #333 !important;
  padding: 16px 12px !important;
}

.modern-text-field :deep(.v-field--readonly .v-field__input) {
  color: #6c757d !important;
}

.modern-text-field :deep(.v-field__input::placeholder) {
  color: #adb5bd !important;
}

/* Icon styling */
.modern-text-field :deep(.v-field__prepend-inner) {
  padding-right: 8px !important;
}

.modern-text-field :deep(.v-field__append-inner) {
  padding-left: 8px !important;
}

/* Clear button styling */
.modern-text-field :deep(.v-field__clearable) {
  margin-left: 4px;
}

.modern-text-field :deep(.v-field__clearable .v-icon) {
  color: #6c757d !important;
  transition: color 0.3s ease !important;
}

.modern-text-field :deep(.v-field__clearable:hover .v-icon) {
  color: #dc3545 !important;
}

/* Error state */
.modern-text-field :deep(.v-field--error .v-field__outline) {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1) !important;
}

.modern-text-field :deep(.v-field--error .v-label) {
  color: #dc3545 !important;
}

/* =============================================================================
   BUTTON STYLES
   ============================================================================= */
.add-prompt-btn {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%) !important;
  color: white !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  border-radius: 12px !important;
  padding: 8px 24px !important;
  min-width: 160px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 3px 12px rgba(25, 118, 210, 0.3) !important;
}

.add-prompt-btn:hover {
  background: linear-gradient(135deg, #1565c0 0%, #0d47a1 100%) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(25, 118, 210, 0.4) !important;
}

.add-prompt-btn .v-icon {
  transition: transform 0.3s ease !important;
}

.add-prompt-btn:focus {
  outline: 2px solid rgba(25, 118, 210, 0.5) !important;
  outline-offset: 2px !important;
}

/* =============================================================================
   DATA TABLE STYLES
   ============================================================================= */
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

.action-divider {
  margin: 0 20px !important;
}

/* =============================================================================
   SWITCH STYLES
   ============================================================================= */
.status-toggle-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.modern-switch {
  transform: scale(1.2);
}

.modern-switch :deep(.v-switch__track) {
  background: #e0e0e0 !important;
  border: none !important;
  border-radius: 50px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.modern-switch :deep(.v-switch__thumb) {
  background: #ffffff !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.modern-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%) !important;
}

.status-text {
  font-size: 0.7rem;
  font-weight: 700;
  color: #bdbdbd;
  transition: color 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.status-text.active {
  color: #4caf50;
}

/* =============================================================================
   DIALOG STYLES
   ============================================================================= */
.modern-dialog {
  margin: 24px;
  animation: dialogSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.2) !important;
}

/* Dialog Content */
.dialog-content {
  padding: 32px 24px !important;
  background: #ffffff;
}

.field-container {
  margin-bottom: 16px;
}

.modern-field :deep(.v-field__outline),
.modern-textarea :deep(.v-field__outline) {
  border-radius: 12px !important;
}

.modern-field :deep(.v-field--focused .v-field__outline),
.modern-textarea :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

/* Dialog Switch */
.status-switch-dialog {
  transform: scale(1.1);
}

.status-switch-dialog :deep(.v-switch__track) {
  background: #e9ecef !important;
  border-radius: 50px !important;
  transition: all 0.3s ease !important;
}

.status-switch-dialog :deep(.v-switch__thumb) {
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease !important;
}

.status-switch-dialog :deep(.v-selection-control--dirty .v-switch__track) {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%) !important;
}

.switch-state-text {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6c757d;
  transition: color 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.switch-state-text.active {
  color: #28a745;
}

/* Dialog Actions */
.dialog-actions {
  padding: 20px 24px !important;
  gap: 12px;
}

.cancel-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  border-color: #dee2e6 !important;
  color: #6c757d !important;
}

.cancel-btn:hover {
  background: #f8f9fa !important;
  border-color: #adb5bd !important;
  color: #495057 !important;
}

.save-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3) !important;
  transition: all 0.3s ease !important;
}

.save-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(25, 118, 210, 0.4) !important;
}

.save-edit-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 12px rgba(255, 164, 7, 0.3) !important;
  transition: all 0.3s ease !important;
}

.save-edit-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(255, 164, 7, 0.4) !important;
}

/* =============================================================================
   ANIMATIONS
   ============================================================================= */
@keyframes fieldFocus {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.01);
  }
  100% {
    transform: scale(1);
  }
}

.modern-text-field :deep(.v-field--focused) {
  animation: fieldFocus 0.3s ease;
}

@keyframes dialogSlideIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* =============================================================================
   RESPONSIVE DESIGN
   ============================================================================= */
@media (max-width: 768px) {
  /* Text Field Responsive */
  .modern-text-field :deep(.v-field__input) {
    font-size: 0.9rem !important;
    padding: 14px 10px !important;
  }

  .modern-text-field :deep(.v-label) {
    font-size: 0.8rem !important;
  }

  /* Dialog Responsive */
  .dialog-header {
    padding: 20px 16px !important;
  }

  .header-icon-container {
    width: 48px;
    height: 48px;
    margin-right: 12px;
  }

  .dialog-title {
    font-size: 1.25rem !important;
  }

  .dialog-content {
    padding: 24px 16px !important;
  }

  .dialog-actions {
    padding: 16px !important;
    flex-direction: column;
  }

  .cancel-btn,
  .save-btn,
  .save-edit-btn {
    width: 100% !important;
    min-width: auto !important;
  }
}
:deep(thead) {
  background-color: #FFE4E1 !important;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
:deep(.v-pagination__first),
:deep(.v-pagination__last) {
  display: none !important;
}
:deep(.v-data-table-footer .v-field) {
  border-radius: 10px !important;
  width: 70px !important;
}
.field-label {
  margin-bottom: 4px;
  color: #171717;
  font-size: 14px;
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-left: 20px;
}
.no-data-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.publication-toggle {
  margin: 0 4px;
}

.publication-toggle :deep(.v-switch__track) {
  transform: scale(0.8);
  width: 40px;
  height: 28px;
  border-radius: 999px;
  border: 2px solid transparent;
  background-color: transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.publication-toggle :deep(.v-switch__thumb) {
  width: 20px;
  height: 20px;
  box-shadow: none;
  border: 2px solid transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.publication-toggle--active :deep(.v-switch__track) {
  background-color: #ffffff !important;
  border-color: #d32f2f;
}

.publication-toggle--active :deep(.v-switch__thumb) {
  background-color: #d32f2f !important;
  border-color: #d32f2f;
  transform: translateX(-0.5px);
}

.publication-toggle--inactive :deep(.v-switch__track) {
  background-color: #bdbdbd !important;
  border-color: #bdbdbd;
}

.publication-toggle--inactive :deep(.v-switch__thumb) {
  background-color: #ffffff !important;
  border-color: #bdbdbd;
  width: 30px;
  height: 30px;
}
.chip-active {
  border-radius: 40px;
  background: #F9E6E6!important;
  color: #A30000 !important;
  font-weight: 600;
  backdrop-filter: blur(10px);
}
.chip-inactive {
  border-radius: 40px;
  background: #F0F0F0!important;
  color: #595959 !important;
  font-weight: 600;
  backdrop-filter: blur(10px);
}
.chunk-dialog-header {
  background: var(--light-gd, linear-gradient(90deg, #E7EBFF -18.26%, #FFF 100%));
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 6px 10px 24px !important;
}
.chunk-dialog-title {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #001763 !important;
  margin: 0 !important;
}
.chunk-confirm-btn {
  background: linear-gradient(135deg, #C32E0E 0%, #F67760 100%);
  color: white !important;
  border: none !important;
  border-radius: 11px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  height: 40px !important;
  min-width: 100px !important;
}
</style>
